













import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class AltCard extends Vue {
  @Prop() title!: string
  @Prop() extra!: string
}
